import {ClienteActionTypes, SAVE_CLIENTE} from "../types/clienteActionTypes";
import {ICliente} from "../../entities/catalogos/ICliente";

const initialState: ICliente = {
    id: 0,
    nombre: "",
    esHomeDelivery: false,
    esRadConCita: false,
    esEadConCita: false,
    esExcluirSeguro: false,
    habilitarClienteLogistico: false,
    documentos:[],
    embalajes:[],
    grupoClienteID:0,
    esClase:false,
    empresaID:0,
    telefono:"",
    rfc:"",
    tipoPersonaID :1,
    adjuntarCarta: false, 
    tieneConveniosHD: false
};

export default function clienteReducer(state = initialState, action: ClienteActionTypes): ICliente {
    switch (action.type) {
        case SAVE_CLIENTE:
            return action.cliente;
        default:
            return state;
    }
}

